import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OutboundSODetailRBAC = {
  pageID: 'f27732474393c538cf283bba79461a7a',
  elementID: {
    ViewContent: '011678daeb5958ddf6aa4abd0915283d',
    MenuItemSave: '4a5c24ecf561eadc8ce7c786e7001375',
    MenuItemEdit: '4a5c88353261eadc8ce7c7870f969fd2',
    MenuItemCopy: '4a5c6c778761eadc8ce7c787041c94a5',
    MenuItemConfirm: '6e90310c5524a522736cdc330cfa452e',
    MenuItemCancel: '6d07f32d8a90c6d299275ad12bd17d88',
  },
} as const

export const useRBACOutboundSODetailPage = createUseRBAC(OutboundSODetailRBAC.elementID)
export type UseRBACOutboundSODetailPageType = ReturnType<typeof useRBACOutboundSODetailPage>
